import React, { useState } from 'react';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
interface LayoutProps {
  children: React.ReactNode;
  currentModule: string;
  onModuleChange: (module: string) => void;
}
export function Layout({
  children,
  currentModule,
  onModuleChange
}: LayoutProps) {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  return <div className="min-h-screen bg-gray-50 dark:bg-gray-900" data-id="element-85">
      <Sidebar currentModule={currentModule} onModuleChange={onModuleChange} isCollapsed={isSidebarCollapsed} onToggleCollapse={() => setIsSidebarCollapsed(!isSidebarCollapsed)} data-id="element-86" />
      <Header isCollapsed={isSidebarCollapsed} data-id="element-87" />
      <main className={`pt-16 min-h-screen transition-all duration-300 ease-in-out ${isSidebarCollapsed ? 'ml-[68px]' : 'ml-64'}`} data-id="element-88">
        <div className="p-6" data-id="element-89">{children}</div>
      </main>
    </div>;
}